import { styled } from '@mui/material';

export const Container = styled('div')(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  userSelect: 'none',

  img: {
    animation: 'spin 1s linear infinite',
    width: '6.375rem',
    height: '6.375rem',

    '@keyframes spin': {
      'to ': {
        transform: 'rotate(360deg)',
      },
    },
  },
}));

export const dialogPaperStyle = { backgroundColor: 'transparent' };
